"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var Match = function Match(start, end, tag) {
  (0, _classCallCheck2["default"])(this, Match);
  this.start = start;
  this.end = end;
  this.tag = tag;
};

var _default = Match;
exports["default"] = _default;